import { trackGtmEvent } from '@gumtree/shared/src/util/gtm-tracker';

export const trackEvents = (action, label, others) => {
    trackGtmEvent({
        action,
        ...(label && { label }),
        others,
    });
};

/**
 * When user selects to rent or to share
 * category, log which has been selected
 */
export const trackPropertySelected = (propertyType) => {
    trackGtmEvent({
        action: 'propertyToRentOrShareSelected',
        label: { propertyType },
    });
};

export const trackAquariumSelected = (aquariumType) => {
    trackGtmEvent({
        action: 'Aquariums',
        label: { aquariumType },
    });
};

export const trackJobsButton = (eventLabel) => {
    trackGtmEvent({
        action: 'PostAdCategory',
        label: eventLabel,
        others: {
            c: {
                c: { id: 2553 },
                l0: { id: 1 },
                l1: { id: 2553 },
            },
        },
    });
};

export const trackJobsPopupClose = (eventLabel) => {
    let originalCategory = undefined;
    if (window.google_tag_manager['GTM-FF7Z'].dataLayer.get('c')) {
        originalCategory = JSON.parse(
            JSON.stringify(window.google_tag_manager['GTM-FF7Z'].dataLayer.get('c'))
        );
    }
    trackGtmEvent({
        action: 'PostAdDeclineCategory',
        label: eventLabel,
        others: {
            c: {
                c: { id: 2553 },
                l0: { id: 1 },
                l1: { id: 2553 },
            },
        },
    });
    // Reset original event category
    window.dataLayer.push({
        c: originalCategory,
    });
};
